import { render, staticRenderFns } from "./DeleteStorgeDialog.vue?vue&type=template&id=344d3f92"
import script from "./DeleteStorgeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteStorgeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports